import { ArrayHelpers, FieldArray, FormikProps } from 'formik';
import { fields } from '@synergy/utils';

import { NotificationSettingFormValues } from '../../../../models/notification-form-values';
import { NotificationsTable } from '../../../../components/notifications/notifications-table';
import { SupplierDetailOverviewFormValues } from '../models/supplier-detail-overview-form-values';

type ArrayHelper = ArrayHelpers & {
    form: FormikProps<SupplierDetailOverviewFormValues>;
    name: string;
};

const fieldNames = fields<SupplierDetailOverviewFormValues>();

export const SupplierDetailOverviewNotifications = () => {
    const handleEdit = (helper: ArrayHelper) => (values: NotificationSettingFormValues) => {
        const formAddresses = helper.form.values.notificationSettings;
        const index = formAddresses.findIndex(a => a.id === values?.id);
        if (index >= 0) {
            helper.replace(index, values);
        }
    };

    const handleDelete = (helper: ArrayHelper) => (values: NotificationSettingFormValues) => {
        const formAddresses = helper.form.values.notificationSettings;
        const index = formAddresses.findIndex(a => a.id === values?.id);
        if (index >= 0) {
            helper.remove(index);
        }
    };

    return (
        <FieldArray name={fieldNames.notificationSettings}>
            {(helper: ArrayHelper) => (
                <NotificationsTable
                    notifications={helper.form.values.notificationSettings}
                    onCreate={values => helper.push(values)}
                    onDelete={handleDelete(helper)}
                    onEdit={handleEdit(helper)}
                />
            )}
        </FieldArray>
    );
};
